/**
 * Input File Component, build-in upload method.
 * Example see ProfileEdit
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../config/i18n';

class InputFile extends Component {
  // default maximum file size set to 25MB
  static defaultProps = {
    maxFileSize: 26214400,
  };

  static propTypes = {
    maxFileSize: PropTypes.number,
  };

  constructor(props) {
    super(props);

    this.state = {
      file: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.getFile = this.getFile.bind(this);
    this.triggerClick = this.triggerClick.bind(this);
    this.checkFileSize = this.checkFileSize.bind(this);
    this.uploadWrapper = this.uploadWrapper.bind(this);
  }

  getFile() {
    return this.state.file;
  }

  handleInputChange(event) {
    const file = event.target.files[0];
    // restore base input value
    event.target.value = null;
    // check size
    if (this.checkFileSize(file) === false) {
      return false;
    }
    this.setState({ file });

    // apply custom on change method.
    return this.props.onSelectFile(file);
  }

  uploadWrapper(uploadMethod, params) {
    // upload photo
    const {
      actions: {
        createAlert,
        createInfoAlert,
        createSuccessAlert,
        createWaringAlert,
        dismissLastAlert,
      },
      maxFileSize,
    } = this.props;
    const formData = new FormData();
    formData.append('file', this.state.file);
    const uploadPromise = uploadMethod(formData, params);

    // Create uploading alert
    createInfoAlert(i18n.t('uploading'), 0);
    uploadPromise
      .then(() => {
        // Dismiss uploading alert
        dismissLastAlert();
        // Create success alert
        setTimeout(() => { createSuccessAlert(i18n.t('uploadCompleted'), 2000); }, 500);
      }).catch((err) => {
        // Dismiss uploading alert
        dismissLastAlert();
        // to match error message for 413 Entity too large, 500 ... Exceeded maxFileSize ...
        if (err.message.match('^(413|500.*maxFileSize)')) {
          createWaringAlert(i18n.t('maxFileSizeExceededMsg', { size: (parseFloat(maxFileSize) / 1048576.0).toFixed(1) }));
        } else {
          createAlert(err, 2000);
        }
      });
    return uploadPromise;
  }

  fileUploadWrapper(file, uploadMethod, params) {
    const {
      actions: {
        createAlert,
        createInfoAlert,
        createSuccessAlert,
        createWaringAlert,
        dismissLastAlert,
      },
      maxFileSize,
    } = this.props;
    const formData = new FormData();
    formData.append('file', file);
    const uploadPromise = uploadMethod(formData, params);

    // Create uploading alert
    createInfoAlert(i18n.t('uploading'), 0);
    uploadPromise
      .then(() => {
        // Dismiss uploading alert
        dismissLastAlert();
        // Create success alert
        setTimeout(() => { createSuccessAlert(i18n.t('uploadCompleted'), 2000); }, 500);
      }).catch((err) => {
        // to match error message for 413 Entity too large, 500 ... Exceeded maxFileSize ...
        if (err.message.match('^(413|500.*maxFileSize)')) {
          createWaringAlert(i18n.t('maxFileSizeExceededMsg', { size: (parseFloat(maxFileSize) / 1048576.0).toFixed(1) }));
        } else {
          createAlert(err, 2000);
        }
      });
    return uploadPromise;
  }

  checkFileSize(file) {
    const {
      actions,
      maxFileSize,
    } = this.props;
    if (file.size >= maxFileSize) {
      actions.createWarningAlert(i18n.t('maxFileSizeExceededMsg', { size: (parseFloat(maxFileSize) / 1048576.0).toFixed(1) }));
      setTimeout(() => { actions.dismissLastAlert(); }, 2500);
      return false;
    }
    return true;
  }

  triggerClick() {
    return this.inputFile.click();
  }

  render() {
    return (
      <div>
        <input
          ref={(ref) => { this.inputFile = ref; }}
          id={this.props.id}
          type="file"
          name={this.props.name}
          className={this.props.className}
          value={this.props.value}
          defaultValue={this.props.defaultValue}
          placeholder={this.props.placeholder}
          style={this.props.style}
          accept={this.props.accept || '.png,.gif,.jpg,.jpeg,.tif,.tiff,.bmp'}
          onChange={this.handleInputChange}
          required={this.props.required}
        />
      </div>
    );
  }
}

export default InputFile;



// WEBPACK FOOTER //
// ./src/components/shared/InputFile.js